import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";

class WarehouseService {
  addProductToWarehouse(idUser, idWarehouse, idProduct, quantity) {
    return api.post(
      UtilsUrl.warehouseURL() +
        "/addProductToWarehouse/" +
        idUser +
        "/" +
        idWarehouse +
        "/" +
        idProduct +
        "/" +
        quantity
    );
  }
  addWarehouse(warehouseModel) {
    return api.post(UtilsUrl.warehouseURL() + "/addWarehouse", warehouseModel);
  }
  updateWarehouse(idUser, idWarehouse, warehouseModel) {
    return api.post(
      UtilsUrl.warehouseURL() +
      "/updateRealWarehouse/" +
      idUser +
      "/" +
      idWarehouse,
      warehouseModel
    );
  }
  setWarehouseDevise(idUser, idWarehouse, devise, name) {
    return api.get(
      UtilsUrl.warehouseURL() +
      "/setWarehouseDevise/" +
      idUser +
      "/" +
      idWarehouse +
      "/" +
      devise +
      "/" +
      name
    );
  }

  getAllWarehouseById(idUser, idWarehouse) {
    return api.get(
      UtilsUrl.warehouseURL() +
      "/getAllWarehouseById/" +
      idUser +
      "/" +
      idWarehouse
    );
  }




  getAllAchatAndCAWarehouseById(idWarehouse) {
    return api.get(
      UtilsUrl.warehouseURL() +
      "/getAllAchatAndCAWarehouseById/" +
      idWarehouse
    );
  }

  getAllWarehouseByIdAndTypeProduct(idUser, idWarehouse, typeProduct) {
    return api.get(
      UtilsUrl.warehouseURL() +
      "/getAllWarehouseByIdAndTypeProduct/" +
      idUser +
      "/" +
      idWarehouse +
      "/" +
      typeProduct
    );
  }

  // params: { months, minQuantity, idWarehouse } (idWarehouse omitted = all warehouses)
  analyseStock(idUser, params) {
    return api.get(UtilsUrl.warehouseURL() + "/analyseStock/" + idUser, {
      params,
    });
  }

  getAllRealWarehouse(idUser, isDeleted) {
    return api.get(
      UtilsUrl.warehouseURL() +
      "/getAllRealWarehouse/" +
      idUser +
      "/" +
      isDeleted
    );
  }


  getAllRealWarehouseForPrice(idUser, isDeleted) {
    return api.get(
      UtilsUrl.warehouseURL() +
      "/getAllRealWarehouseForPriceSell/" +
      idUser +
      "/" +
      isDeleted
    );
  }
  getAllVirtualWarehouse(idUser, isDeleted) {
    return api.get(
      UtilsUrl.warehouseURL() +
      "/getAllVirtualWarehouse/" +
      idUser +
      "/" +
      isDeleted
    );
  }
  getAllWarehouse(idUser) {
    return api.get(UtilsUrl.warehouseURL() + "/getAllWarehouse/" + idUser);
  }
  getProductTransactionHistoryByWarehouseColis(idWarehouse, idUser, type) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
      "/getProductTransactionHistoryByWarehouseColis/" +
      idWarehouse +
      "/" +
      idUser +
      "/" +
      type
    );
  }
  getTransactionHistoryByTransactionId(
    idWarehouse,
    idUser,
    type,
    refTransaction
  ) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
      "/getTransactionHistoryByTransactionId/" +
      idWarehouse +
      "/" +
      idUser +
      "/" +
      type +
      "/" +
      refTransaction
    );
  }
  getProductTransactionHistoryByWarehouse(idWarehouse, idUser, type) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
      "/getProductTransactionHistoryByWarehouse/" +
      idWarehouse +
      "/" +
      idUser +
      "/" +
      type
    );
  }

  getProductTransactionHistoryByWarehouseBetweenDates(
    idWarehouse,
    idUser,
    type,
    dateBegin,
    dateEnd
  ) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
      "/getProductTransactionHistoryByWarehouse/" +
      idWarehouse +
      "/" +
      idUser +
      "/" +
      type +
      "/" +
      dateBegin +
      "/" +
      dateEnd
    );
  }

  deleteWarehouseManager(idUser, idWarehouse, idManager) {
    return api.get(
      UtilsUrl.warehouseURL() +
      "/deleteWarehouseManager/" +
      idUser +
      "/" +
      idWarehouse +
      "/" +
      idManager
    );
  }
  dataForFixedSellingPrice(idUser, idWarehouse, idProduct) {
    return api.get(
      UtilsUrl.warehouseURL() +
      "/dataForFixedSellingPrice/" +
      idUser +
      "/" +
      idWarehouse +
      "/" +
      idProduct
    );
  }
  getListInventaireWarehouse(idUser, idWarehouse) {
    return api.get(
      UtilsUrl.warehouseURL() + "/listInventaire/" + idUser + "/" + idWarehouse
    );
  }

  // type : "TOTAL" = inventaire de la totalité des produits du dépôt,
  // "SELECTION" (défaut du serveur) = seulement les articles présents dans le fichier
  addInventaireExcel(idUser, idWarehouse, picture, type = "SELECTION") {
    return api.post(
      UtilsUrl.warehouseURL() +
      "/addInventaireExcel/" +
      idUser +
      "/" +
      idWarehouse,
      picture,
      {
        headers: { "Content-Type": "multipart/form-data" },
        params: { type },
      }
    );
  }

  validateInventaireExcel(idUser, idWarehouse, picture, type = "SELECTION") {
    return api.post(
      UtilsUrl.warehouseURL() +
      "/validateInventaireExcel/" +
      idUser +
      "/" +
      idWarehouse,
      picture,
      {
        headers: { "Content-Type": "multipart/form-data" },
        params: { type },
      }
    );
  }

  getInventaireById(idUser, idInventaireWarehouse) {
    return api.get(
      UtilsUrl.warehouseURL() +
      "/getInventaireById/" +
      idUser +
      "/" +
      idInventaireWarehouse
    );
  }
  getAllPriceWarehouse = (idUser) => {

    return api.get(
      `/retail/warehouse/getAllPriceWarehouse/${idUser}/0`
    );
  };
  getOrderByRef(idUser, reference) {
    return api.get(
      UtilsUrl.OrderPosURL() +
      `/getOrderByRef/${reference}/${idUser}`
    );
  }
  addStockMinToProductStockByExcel = (idUser, idWarehouse, formData) => {
    return api.get(
      `/retail/warehouse/updateStock/addStockMinToProductStockByExcel/${idUser}/${idWarehouse}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      }
    }
    );
  };
  addStockMinToProductStock = (idUser, idWarehouse, barrecode, qteMin) => {
    return api.put(
      `/retail/warehouse/updateStockByProduct/addStockMinToProductStock/${idUser}/${idWarehouse}/${barrecode}/${qteMin}`
    )
  }
  addStockMaxToProductStock = (idUser, idWarehouse, barrecode, qteMin) => {
    return api.put(
      `/retail/warehouse/updateStockByProduct/addStockMaxToProductStock/${idUser}/${idWarehouse}/${barrecode}/${qteMin}`
    )
  }


  stockProductsInAllWarehouses = (idUser, idProduct) => {
    return api.get(
      `/retail/warehouse/stockProductsInAllWarehouses/${idUser}/${idProduct}`
    )
  }


  getWarehousesBySocieteAndProduct = (idUser, idProduct) => {
    return api.get(
      `/retail/warehouse/getWarehousesBySocieteAndProduct/${idUser}/${idProduct}`
    )
  }
  getWarehousesByQctInvalid = (idUser) => {
    return api.get(
      `/retail/warehouse/qct/getWarehousesByQctInvalid/${idUser}`
    )
  }
  getProductStockByWarehouseAndQctInvalid = (idUser ,idWarehouse) => {
    return api.get(
      `/retail/warehouse/qct/getProductStockByWarehouseAndQctInvalid/${idUser}/${idWarehouse}`
    )
  }
    checkStockByProductQteAndProductPrice = (idUser ,barcode,idWarehouse) => {
    return api.get(
      `/retail/warehouse/checkStockByProductQteAndProductPrice/${idUser}/${barcode}/${idWarehouse}`
    )
  }

     priceAchatProductWarehouse = (idUser ,idProduct,idWarehouse) => {
    return api.get(
      `/retail/warehouse/priceAchatProductWarehouse/${idUser}/${idProduct}/${idWarehouse}`
    )
  }

      priceVenteProductWarehouse = (idUser ,idProduct,idWarehouse) => {
    return api.get(
      `/retail/warehouse/priceVenteProductWarehouse/${idUser}/${idProduct}/${idWarehouse}`
    )
  }

  updateStockPack = (idWarehouse) => {
    return api.get(
      `/retail/warehouse/croneUpdateQtePack/${idWarehouse}`
    )
  }

   getWarehouseSummary = (idWarehouse) => {
    return api.get(
      `/retail/warehouse/getWarehouseSummary/${idWarehouse}`
    )
  }

     getAllProductsWarehouseById(idWarehouse, params = {}) {
         const {
        page = 0,
        size = 10,
        sortDirection = 'ASC',
        sortBy = 'id'
      } = params;
    return api.get(
      UtilsUrl.warehouseURL() +"/"+idWarehouse+
      "/products" ,
      {
        params: {
          page,
          size,
          sortDirection,
          sortBy
        }}
    );
  }


       getSearchProductsWarehouseById(idWarehouse, params = {}) {
         const {
        page = 0,
        size = 10,
        q="",
      } = params;
    return api.get(
      UtilsUrl.warehouseURL() +"/"+idWarehouse+
      "/products/search" ,
      {
        params: {
          page,
          size,
          q
        }}
    );
  }


       exportWarehouseExcel(idUser,idWarehouse) {
   return api.get(
     UtilsUrl.warehouseURL() + `/export-discount-excel`,
    {
      params: { idUser ,idWarehouse},
      responseType: "blob", // 🔴 VERY IMPORTANT
    }
  );
  }

  searchProductsStockInWarehouse(idUser, idWarehouse, search) {
    return api.get(
      UtilsUrl.warehouseURL() +
        "/searchProducts/" +
        idUser +
        "/" +
        idWarehouse,
      { params: { search } }
    );
  }

}

export default new WarehouseService();
